export default "__VITE_PUBLIC_ASSET__c4ca98ff__"